<template>
  <div class="body-common pd16" v-if="dataDetail">
    <h1 class="font18 mtb16">课程导读</h1>
    <div
      class="color-gray2 font14"
      v-html="dataDetail.albumDescription && dataDetail.albumDescription.replace(/\n/g, '<br />')"
    ></div>
    <h1 class="font18 mtb16">课程导读</h1>
    <div class="flexdiv wrap mediablock">
      <div
        v-for="(item, index) in dataDetail.mainTeachers"
        :key="index"
        class="media blockdiv media-updown txt-center bg-gray border-radius8 pd10"
      >
        <div class="media-object fullwidth">
          <img class="border-radius50" style="height: 100px; width: 100px" :src="item.avtarUrl" />
        </div>
        <div class="media-body">
          <div class="media-heading">{{ item.teacherName }}</div>
          <p class="color-gray3" v-html="item.brief"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { appUser } from '@/utils'
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import { Indicator } from 'mint-ui'
import { saTrack } from '@/utils/common/shence'
import service from '@/api/modules/payment/album'
export default {
  name: 'AlbumDetail',
  data() {
    return {
      title: '专辑详情',
      dataDetail: null
    }
  },
  mixins: [Body],
  methods: {
    getDetail() {
      service
        .getAlbumInfo({
          shareCode: this.shareCode
        })
        .then(res => {
          this.dataDetail = res
        })
    },
    // 设置分享数据
    setShareData() {
      const { sharerNickName: title, shareTitle, shareIcon, shareSubTitle } = this.dataDetail
      if (title) {
        return {
          title: `${title}邀请你听《${shareTitle}》`,
          desc: `${shareSubTitle}`,
          link: location.href,
          imgUrl: shareIcon
        }
      }
    }
  },
  computed: {
    ...mapGetters('args', ['shareCode'])
  },
  created() {
    this.getDetail()
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.mediablock {
  .media {
    width: calc(50% - 16px);
  }
}
</style>
